import { render, staticRenderFns } from "./doctor-detail.vue?vue&type=template&id=0aac90f1&"
import script from "./doctor-detail.vue?vue&type=script&lang=js&"
export * from "./doctor-detail.vue?vue&type=script&lang=js&"
import style0 from "./doctor-detail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex, CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList})
